import { useCallback } from 'react';
import { UseFieldArrayRemove } from 'react-hook-form';

import { ValidationItems } from '@kanda-libs/ks-component-ts';

import useIncomeExpenseValidation from '../../useIncomeExpenseValidation';

export interface ExpenseItemHook {
  removeItem: () => void;
  selectValidation: ValidationItems;
  amountValidation: ValidationItems;
}

export default function useExpenseItem(
  index: number,
  remove: UseFieldArrayRemove,
): ExpenseItemHook {
  const removeItem = useCallback(() => remove(index), [remove, index]);
  const { selectValidation, amountValidation } = useIncomeExpenseValidation(
    index,
    'expense',
  );

  return {
    removeItem,
    selectValidation,
    amountValidation,
  };
}
